import React, { useEffect, useState } from 'react'
import { Button, Col, Modal, Row } from 'react-bootstrap'

const ImageViewer = (props) => {
    const imgCounter = parseInt(props.imagecounter)
    const [imageUrl, setImageUrl] = useState(props.imagesrc)
    const loadPrev = (data) => {
        let newData = 0
        if (data === 0)
            newData = imgCounter
        else
            newData = data - 1
        setImageUrl(newData)
    }

    const loadNext = (data) => {
        let newData = 0
        if (data === imgCounter)
            newData = 0
        else
            newData = data + 1
        setImageUrl(newData)
    }

    useEffect(() => {
        setImageUrl(props.imagesrc)
    }, [props.imagesrc])

  return (
    <>
      <Modal
			{...props}
			size="lg"
			aria-labelledby="contained-modal-title-vcenter"
			centered
		>
			<Modal.Body>
				<div className=''>
                    <img className='img-fluid furniture-image-viewer' src={'/'+props.imagedir + imageUrl + '.' + props.mimetype} alt={imageUrl} />
				</div>
			</Modal.Body>
            <Row className='pb-3 text-center'>
                <Col xs={{span:3, offset:2}} md={{span:2, offset:3}} className="text-right">
                    <Button onClick={() => loadPrev(imageUrl)}  className="product-modal-prev-button btn-warning"><img className='popup-modal-prev-icon' src={"/assets/icons/left.png"}  alt="close" /></Button>
                </Col>
                <Col xs={{span:2, offset:0}}  md={{span:2, offset:0}} className="text-center no-padding-x">
                    <Button onClick={props.onHide} className="product-modal-cross-button btn-warning"><img className='popup-modal-cross-icon' src={"/assets/icons/close-icon.png"}  alt="close" /></Button>
                </Col>
                <Col xs={{span:3, offset:0}} md={{span:2, offset:0}}  className="text-left">
                    <Button onClick={() => loadNext(imageUrl)} className="product-modal-next-button btn-warning"><img className='popup-modal-next-icon' src={"/assets/icons/right.png"}  alt="close" /></Button>
                </Col>
            </Row>
    	</Modal>
    </>
  )
}

export default ImageViewer
